export const CheckInMapping = {
    checkInRouter: '/checkin/:locationCode',
};

export const CheckInApi = {
    getInfoBranchById: '/booking-online/get-info-branch',
    getBookingInday: '/booking-online/get-booking-by-phone',
    getBookingById: '/booking-online/get-booking-by-id',
    checkInBooking: '/booking-online/check-in',
}